module.exports = __webpack_public_path__ + "img/logo.27815c54.png";